<!-- eslint-disable -->
<template lang="pug">
    .multiplayer-game-menu__selectors
        cs-multiselect.selector.amount-of-examples-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="selectedAmountOfExamples",
            :options="amountsOfExamples",
            :disabled="gameState === 'started' || commonParams && (!!commonParams.timeLimit || commonParams.infinityAmountOfExamples)"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
                |
        cs-multiselect.selector.multipliers(
            :multiple="true",
            :show-labels="false",
            :searchable="false",
            :close-on-select="false",
            :allow-empty="false",
            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_multipliers')"
            v-model="selectedMultipliers",
            :options="multipliersOptions",
            :tags-limit="tagsLimit"
            :disabled="gameState === 'started'"
        )
        cs-multiselect.selector.players-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="playersAmount",
            :options="players",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameSetting_players') }}:
                |
</template>

<script>
    /*eslint-disable*/
    import MultiplayerOptionsMixin from '../../../utils/multiplayer/optionsMixin';
    import { cloneDeep } from 'lodash';

    const INFINITE_AMOUNT_OF_EXAMPLES_PARAMETER = 'infinityAmountOfExamples';
    const COMMON_PARAMETERS_CHANGED_EVENT = 'commonParametersHasChanged';

    export default {
        mounted() {
            this.selectedAmountOfExamples = this.commonParams.amountOfExamples;
            this.selectedMultipliers = this.commonParams.numbers;
            if (this.commonParams.combining) {
                this.isCombiningEnabled = true;
                this.selectedCombiningOptions = this.combiningOptions.filter(option => {
                    return this.commonParams.combiningDigitCapacities.includes(option.value);
                });
            }
            this.selectedInfiniteAmountOfExamplesStatus = this.infiniteOptions.find(
                option => option.status === this.commonParams.infinityAmountOfExamples
            );
        },
        watch: {
            selectedAmountOfExamples: {
                handler(value, oldValue) {
                    if (oldValue !== 0) {
                        this.commonParams.amountOfExamples = value;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                            name: 'amountOfExamples',
                            value: this.commonParams.amountOfExamples,
                        });
                    }
                },
            },
            selectedMultipliers: {
                handler(value, oldValue) {
                    if (oldValue.length) {
                        this.commonParams.numbers = value;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                            name: 'numbers',
                            value: this.commonParams.numbers,
                        });
                    }
                },
            },
            combiningOptions: {
                handler(value, oldValue) {
                    if (
                        oldValue &&
                        oldValue.length &&
                        this.selectedCombiningOptions &&
                        this.selectedCombiningOptions.length
                    ) {
                        this.selectedCombiningOptions = value;
                    }
                },
                deep: true,
            },
            selectedCombiningOptions: {
                handler(value, oldValue) {
                    this.handleMultiselectStyleState(!(value && value.length));
                    if (oldValue !== null) {
                        if (value && value.length) {
                            if (value.length < 2) {
                                this.selectedCombiningOptions.push(
                                    this.combiningOptions.find(option => !value.includes(option))
                                );
                                return;
                            }
                            this.commonParams.combining = true;
                            this.commonParams.combiningDigitCapacities = value.map(option => option.value);
                        } else {
                            this.commonParams.combining = false;
                            this.commonParams.combiningDigitCapacities = [];
                        }
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                            setCombiningValues: true,
                            names: ['combining', 'combiningDigitCapacities'],
                            values: [this.commonParams.combining, this.commonParams.combiningDigitCapacities],
                        });
                    }
                },
                deep: true,
            },
            selectedInfiniteAmountOfExamplesStatus: {
                handler(value, oldValue) {
                    if (oldValue !== null) {
                        this.commonParams.infinityAmountOfExamples = value.status;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {
                            name: INFINITE_AMOUNT_OF_EXAMPLES_PARAMETER,
                            value: value.status,
                        });
                    }
                },
            },
        },
        mixins: [MultiplayerOptionsMixin],
        data() {
            return {
                selectedDifficulty: null,
                selectedAmountOfExamples: 0,
                selectedMultipliers: [],
                amountsOfExamples: [...Array(101).keys()].slice(1),
                infiniteOptions: [
                    {
                        status: true,
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated'),
                    },
                    {
                        status: false,
                        label: this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated'),
                    },
                ],
                multipliersOptions: [...Array(11).keys()].slice(2),
                selectedInfiniteAmountOfExamplesStatus: null,
            };
        },
        methods: {
            removeSelectedCombiningOptions(removedOption) {
                if (this.selectedCombiningOptions.length > 2) {
                    this.selectedCombiningOptions = this.selectedCombiningOptions.filter(
                        option => option.value !== removedOption.value
                    );
                }
            },
            combiningHandler() {
                this.isCombiningEnabled = !this.isCombiningEnabled;
                if (!(this.selectedCombiningOptions && this.isCombiningEnabled)) {
                    this.selectedCombiningOptions = [];
                }
            },
            handleMultiselectStyleState(removeStyles) {
                //set last multiselect tags to be in one height with another
                let combiningMultiselectTags = document.querySelectorAll('.multiselect__tags')[4];
                if (combiningMultiselectTags) {
                    combiningMultiselectTags.style.cssText = removeStyles ? '' : 'padding: 8px 15px';
                }
            },
        },
        computed: {
            tagsLimit() {
                if (window.screen.width < 1439) {
                    return 1;
                }
                if (window.screen.width < 1839) {
                    return 2;
                }
                return 9;
            },
            combiningOptions() {
                if (this.selectedDifficulty && this.selectedDifficulty.value > 1) {
                    let options = cloneDeep(this.difficulties);
                    return options
                        .filter(option => {
                            return option.value <= this.selectedDifficulty.value;
                        })
                        .map(option => {
                            return {
                                label: option.label,
                                value: option.value,
                                $isDisabled: false,
                            };
                        });
                }
                return [];
            },
            combiningDisabled() {
                return this.gameState === 'started' || (this.selectedDifficulty && this.selectedDifficulty.value === 1);
            },
        },
    };
</script>

<style scoped lang="scss">
    .multiplayer-game-menu__selectors {
        display: flex;
        width: 80%;
        margin: 20px;
        @media screen and (max-width: 1839px) {
            flex-wrap: wrap;
        }
    }
    .selector {
        margin: 0 10px;
        max-height: 44px;
        &:first-child {
            margin-left: 0;
        }
        @media screen and (max-width: 1839px) {
            max-width: 150px;
        }
        @media screen and (max-width: 1439px) {
            margin: 0 5px;
            max-width: 130px;
        }
    }
    .digits-combining-selector {
        width: 190% !important;
        margin: 0 20px 0 0;
        @media screen and (max-width: 1839px) {
            max-width: 310px;
        }
    }
    .players-selector {
        width: 85% !important;
        margin-left: 0;
        @media screen and (max-width: 1382px) {
            margin-top: 10px;
        }
    }
    .combining-checkbox-selector {
        max-height: 44px;
        display: flex;
        align-items: center;
        @media screen and (max-width: 1382px) {
            margin-top: 10px;
        }
    }
</style>
